import { avatarType } from '../pipes/avatar-type.pipe';
import { AutoCompleteItem } from '../services/email-autocomplete.service';

const getMentionProfileImage = (user: AutoCompleteItem, avatar) => {
  if (avatarType(user) === 'image') {
    return `<img class="avatar" src="${avatar}" alt="" />`;
  } else {
    return `<div class="avatar">${avatar}</div>`;
  }
};

export const getMentionHtml = (user: AutoCompleteItem, avatar) => {
  return `<mention data-user-id="${user.id}">
      ${getMentionProfileImage(user, avatar)}
        <span>${user.first_name ? user.first_name : 'Unnamed User'}${user.last_name ? ` ${user.last_name}` : ''}</span>
      </mention>`;
};

export const getMentionComponentString = (user: AutoCompleteItem) => {
  return `<app-mention data-user-id="${user.id}" [user]="${JSON.stringify(user).replaceAll('"', "'")}"></app-mention>`;
};
